import { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { OptionDropdown, Icon } from '@oliasoft-open-source/react-ui-library';
import { disabledFieldsUpdated } from 'store/entities/cost-tracker/cost-tracker';
import { costTrackerFields } from 'src/enums/cost-tracker';
import translations from 'src/internationalisation/translation-map.json';
import { convertToKebabCase } from 'src/common/utils/string-utils';

type TColumnOption = {
  label: string;
  value: costTrackerFields;
  selected: boolean;
  testId?: string;
};

type TColumnEditProps = {
  labelConfig?: { [key: string]: string };
} & PropsFromRedux;

const getDefaultSectionCheckboxTestId = (label: string): string => {
  return `default-section-${convertToKebabCase(label)}-checkbox`;
};

const EditColumns = ({ disabledFieldsUpdated, labelConfig = {} }: TColumnEditProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<TColumnOption[]>([
    {
      label: t(translations.costTracker_costType),
      value: costTrackerFields.COST_TYPE,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(t(translations.costTracker_costType)),
    },
    {
      label: labelConfig?.[costTrackerFields.COST_AFE] || t(translations.costTracker_costAfe),
      value: costTrackerFields.COST_AFE,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(
        labelConfig?.[costTrackerFields.COST_AFE] || t(translations.costTracker_costAfe),
      ),
    },
    {
      label: 'Suggested Actual Cost',
      value: costTrackerFields.COST_SUGGESTED,
      selected: true,
      testId: getDefaultSectionCheckboxTestId('Suggested Actual Cost'),
    },
    {
      label: t(translations.costTracker_costActual),
      value: costTrackerFields.COST_ACTUAL,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(t(translations.costTracker_costActual)),
    },
    {
      label: t(translations.timeTracker_variance),
      value: costTrackerFields.VARIANCE,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(t(translations.timeTracker_variance)),
    },
    {
      label: t(translations.timeTracker_finishTime),
      value: costTrackerFields.FINISH,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(t(translations.timeTracker_finishTime)),
    },
    {
      label: costTrackerFields.SEVERAL_OPERATIONS_COST,
      value: costTrackerFields.SEVERAL_OPERATIONS_COST,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(costTrackerFields.SEVERAL_OPERATIONS_COST),
    },
  ]);

  const icon: any = <Icon icon="settings" size="16px" />;
  return (
    <OptionDropdown
      testId="edit-columns-dropdown"
      onChange={(e: any) => {
        setOptions(e.target.value);
        const disabledFields: string[] = e.target.value
          .filter((item: TColumnOption) => item.selected === false)
          .map((item: TColumnOption) => item.value);
        disabledFieldsUpdated(disabledFields);
      }}
      options={options}
      label={icon}
      showHeader={false}
    />
  );
};

const mapDispatchToProps = { disabledFieldsUpdated };

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = connector(EditColumns);

export { Container as EditColumns };
